import { useEffect, useState } from 'react'

import {
  ApolloClient,
  DocumentNode,
  NormalizedCacheObject,
  OperationVariables,
} from '@apollo/client'

import { atlasClient } from 'graphql/client'

type UseWatchQueryInput<T = any> = {
  query: DocumentNode
  variables: T
  client?: ApolloClient<NormalizedCacheObject>
}
const useWatchQuery = <Data = {}, Vars extends OperationVariables = {}>({
  query,
  variables,
  client = atlasClient,
}: UseWatchQueryInput<Vars>) => {
  const [cachedData, setCachedData] = useState<Data | null>(null)

  const observable = client.watchQuery<Data, Vars>({
    query,
    variables,
  })

  useEffect(() => {
    const sub = observable.subscribe((next) => {
      if (next?.data) {
        setCachedData(next.data)
      }
    })
    return () => {
      sub?.unsubscribe()
    }
  }, [observable])

  return cachedData
}

export default useWatchQuery
